// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sr-c";
export var backButton = "_sr-4";
export var backIcon = "_sr-5";
export var chevronShortcut = "_sr-6";
export var container = "_sr-1";
export var editor = "_sr-8";
export var editorWrapper = "_sr-7";
export var prefix = "_sr-2";
export var searchIcon = "_sr-3";
export var suffix = "_sr-9";
export var suffixContent = "_sr-a";
export var suffixText = "_sr-b";
export var wrapper = "_sr-0";